import React from "react";
import { createPortal } from "react-dom";
import { FaSpinner } from "react-icons/fa";

const Loader = ({ isLoading }) => {
  if (!isLoading) return null;

  return createPortal(
    <div className="fixed inset-0 flex items-center justify-center bg-gray-300 bg-opacity-50 backdrop-blur-md z-[9998]">
      <div className="flex flex-col items-center bg-white p-6 rounded-lg shadow-lg">
        <FaSpinner className="animate-spin text-4xl text-[#994263]" />
        <p className="mt-2 text-gray-700">Loading, please wait...</p>
      </div>
    </div>,
    document.body
  );
};

export default Loader;
